<template>
<div class="wrapper">
  <Slider></Slider>
  <NaviBar></NaviBar>
  <ContentWrap class="sl-ml sl-full"></ContentWrap>
</div>
</template>

<script>
import NaviBar from './NaviBar.vue'
import ContentWrap from 'ContentWrap.vue'
import Slider from 'Slider'
export default {
  name: 'dash',
  components: {
    NaviBar,
    Slider,
    ContentWrap
  }
}
</script>

<style>
.wrapper {
  min-height: 100%;
}
@media screen and (max-width:900px) {
  .sl-full.sl-ml {
    margin-left: 0 !important;
  }
}

.sl-ml {
  margin-left: 220px !important;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?eaeef67c